import React from "react"
import { connect } from "react-redux"
import Card, { TitleCard } from "../../core/Card"
import Line from "../../core/Line"
import {
  ForwardIcon,
  Icon,
  PlusIcon,
  MarkerIcon,
  BankCardIcon
} from "../../core/icons"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import {
  Slider,
  Select,
  Button,
  Col,
  Row,
  Popover,
  Icon as AIcon,
  Switch
} from "antd"
// import New from './New'
// import Update from './Update'
import EmptyState from "../../core/components/EmptyState"

const InstitutionLine = ({
  onClick,
  token_id,
  institution_name,
  last_sync,
  ...props
}) => (
  <Line
    onClick={() => {
      onClick(token_id)
    }}
  >
    <Col span={2}>
      <BankCardIcon />
    </Col>
    <Col span={12}>{institution_name}</Col>
    <Col span={8}>
      {last_sync && (
        <span style={{ fontSize: 14, opacity: 0.5 }}>
          last refresh: {last_sync}
        </span>
      )}
    </Col>
    <Col span={1}>
      <ForwardIcon />
    </Col>
  </Line>
)

const All = ({
  onClick,
  integrations,
  pristine,
  disabled,
  loading,
  save,
  dispatch,
  bankAccounts,
  bankNames,
  institution_users,
  addBank
}) => (
  <div>
    <TitleCard sticky>
      <h1>Bank / Card Integrations</h1>

      <Button onClick={addBank} type="primary">
        Add Bank or Credit Card
      </Button>
    </TitleCard>

    <Card>
      {institution_users.length > 0 ? (
        institution_users.map((props, i) => (
          <InstitutionLine key={i} onClick={onClick} {...props} />
        ))
      ) : (
        <EmptyState
          title="No connected bank or card yet."
          // buttonLink="/account/bank-card/new"
          // buttonText="Add Bank or Credit Card"
          // buttonIcon='plus'
          icon={BankCardIcon}
        />
      )}
    </Card>
  </div>
)

export default All



// WEBPACK FOOTER //
// ./src/account/bank-card/All.js